<div class="product-tax-control" [class.compact]="compact">
  <div class="tax-mode">
    <span class="tax-label">{{ "goods.tax.fields.tax_override_mode" | translate }}</span>
    <div class="tax-mode-options">
      @for (option of modeOptions; track option.value) {
        <div class="tax-radio-option">
          <p-radiobutton
            [inputId]="idPrefix + '-mode-' + option.value"
            [name]="idPrefix + '-mode'"
            [value]="option.value"
            [ngModel]="value.mode"
            [disabled]="disabled"
            (ngModelChange)="onModeChange($event)"
          ></p-radiobutton>
          <label [for]="idPrefix + '-mode-' + option.value">
            {{ option.label | translate }}
          </label>
        </div>
      }
    </div>
  </div>

  @if (isOverrideMode) {
    <div class="tax-fields">
      <div class="tax-field tax-category-field">
        <label>{{ "goods.tax.fields.tax_category" | translate }}</label>
        <p-select
          [options]="taxOptions"
          optionLabel="label"
          optionValue="value"
          [ngModel]="displayValue.taxId"
          [disabled]="controlsDisabled"
          [showClear]="true"
          [placeholder]="'goods.tax.placeholders.select_tax_category' | translate"
          appendTo="body"
          styleClass="w-full"
          (ngModelChange)="onTaxIdChange($event)"
        ></p-select>
      </div>

      <div class="tax-field tax-vat-control-field">
        <span class="tax-label">{{ "goods.tax.fields.price_include_vat" | translate }}</span>
        <div class="tax-vat-field">
          <p-checkbox
            [binary]="true"
            [ngModel]="displayValue.isPriceIncludeVAT === true"
            [disabled]="controlsDisabled"
            [inputId]="idPrefix + '-vat'"
            (onChange)="onVatChange($event)"
          ></p-checkbox>
        </div>
      </div>
    </div>
  } @else {
    <div class="tax-inherited-summary">
      <div class="tax-summary-field">
        <span class="tax-label">{{ "goods.tax.inherited_config" | translate }}</span>
        <span class="tax-summary-value">
          {{ inheritedTaxCategoryLabel || ("goods.tax.unconfigured" | translate) }}
        </span>
      </div>

      <div class="tax-summary-field">
        <span class="tax-label">{{ "goods.tax.fields.price_include_vat" | translate }}</span>
        <span class="tax-summary-value">{{ inheritedVatKey | translate }}</span>
      </div>

      @if (sourceKey) {
        <div class="tax-source">
          <p-tag [value]="sourceKey | translate" severity="secondary"></p-tag>
        </div>
      }
    </div>
  }
</div>
